import React from "react";
import { FaRegArrowAltCircleLeft } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import LogoutIcon from '@mui/icons-material/Logout';
import axios from "axios";
import APIURL from "../api/apiClient";

const FooterWrapper = styled.div`
 position: absolute;
    bottom: 0;
    width: 100%;
    height: 80px;
    -webkit-box-shadow: 0px -10px 14px -10px rgba(0, 0, 0, 0.22);
    box-shadow: 0px -10px 14px -10px rgba(0, 0, 0, 0.22);
    display: flex;
    justify-content: center;
    align-items: center;
`;

const FooterContent = styled.div`
  font-size: 14px;
  color: #000000;
  font-weight: bold;
`;

const LogoutButton = styled.button`
  background: none;
  color: #34495e;
  border: 1px dotted #adb5bdff ;
  padding: 10px 20px;
  font-size: 14px;
  font-weight: bold;
  cursor: pointer;
  border-radius: 5px;
  transition: 0.3s ease-in-out;

  &:hover {
    background: linear-gradient(15deg, #d4f3e6 0%, #8bcde3 100%); /* 20% lighter */
  }
`;

const Logout = () => {
    const navigate = useNavigate();


    const handleLogout = async () => {
        const isConfirmed = window.confirm('Are you sure you want to logout?');

        if (!isConfirmed) return; // Exit if user cancels

        try {
            const response = await axios.get(`${APIURL.baseURL}/logout.php`, { withCredentials: true });

            if (response.data.success) {
                localStorage.removeItem('employee_id');
                localStorage.removeItem("username"); // clear username
                localStorage.removeItem("userRole");
                navigate("/login"); // Redirect only on successful logout
            } else {
                console.error("Logout API failed:", response.data.message);
            }
        } catch (error) {
            console.error("Logout failed:", error);
        }
    };


    return (
        <FooterWrapper>
            <FooterContent>
                <LogoutButton onClick={handleLogout}> <LogoutIcon /> Log Out</LogoutButton>
            </FooterContent>
        </FooterWrapper>
    );
};

export default Logout;
